import { render, staticRenderFns } from "./rich_viewer.vue.js?vue&type=template&id=5fc47aa8&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./rich_viewer.vue?vue&type=template&id=5fc47aa8&vue3"
import script from "./rich_viewer.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./rich_viewer.vue?vue&type=script&lang=js&vue3"
export * from "./rich_viewer.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./rich_viewer.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports